import { render, staticRenderFns } from "./ticket-details.vue?vue&type=template&id=f6626b26"
import script from "./ticket-details.vue?vue&type=script&lang=js"
export * from "./ticket-details.vue?vue&type=script&lang=js"
import style0 from "./ticket-details.vue?vue&type=style&index=0&id=f6626b26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports